// extracted by mini-css-extract-plugin
export var typingIndicator = "_nj-0";